
export const TAG_DATA_FIELDS = {
    VIEW_TYPE: 'view-type',
    DISPLAY_TYPE: 'display-type',
    BADGE: 'badge',
    BADGE_IMAGE: 'badge-image',
    TITLE: 'title',
    TITLE_OVERRIDE: 'title-override',
    SUBTITLE: 'subtitle',
    REVIEW_SCORE: 'rating',
    REVIEW_SCORE_OVERRIDE: 'rating-override',
    COMMUNITY_RATING: 'community-rating',
    DESCRIPTION: 'description',
    DESCRIPTION_OVERRIDE: 'description-override',
    SEO_DESCRIPTION: 'seo-description',
    SEO_DESCRIPTION_OVERRIDE: 'seo-description-override',
    IMAGE: 'image',
    VIGNETTE_ID: 'vignette-id',
    VIGNETTE_NAME: 'vignette-name',
    IMAGE_OVERRIDE: 'image-override',
    SPECS: 'specs',
    AFFILIATE_LINKS: 'affiliate-links',
    AFFILIATE_LINKS_OVERRIDE: 'affiliate-links-override',
    PROSCONS: 'proscons',
    PROS: 'pros',
    CONS: 'cons',
    TAG_VIDEO_THUMBNAIL: 'tag-video-thumbnail',
    TAG_VIDEO: 'tag-video',
    EMBARGO_SCORE_IS_INCLUDED: 'embargo-score-is-included',
};



// WEBPACK FOOTER //
// ./js/utils/consts/tag_data_fields.ts